import type { Role } from '@routeback/core';

export const ROLE_LABEL: Record<Role, string> = {
  owner: 'Owner',
  admin: 'Admin',
  manager: 'Manager',
  driver: 'Driver',
  mechanic: 'Mechanic',
};

export const ROLE_HELP: Record<Exclude<Role, 'owner'>, string> = {
  admin: 'Everything a manager can do, plus company settings, email recipients, exports and deleting records.',
  manager: 'Maintenance, schedules, time off, documents, write-ups and the other manager tools.',
  driver: 'Their own requests, documents and forms; sees trucks, the schedule and the lineup.',
  mechanic: 'Only work orders you send to the mechanic, plus trucks, parts and mileage. Sees nothing else. Free — one shop login can work for several companies.',
};

export function roleLabel(role: Role | string | null | undefined): string {
  return ROLE_LABEL[role as Role] ?? String(role ?? '');
}
